export const CLICKED_TO_FORWARD = 'CLICKED_TO_FORWARD';
export const CLICKED_TO_CLOSE_FORWARD_COMMUNICATOR = 'CLICKED_TO_CLOSE_FORWARD_COMMUNICATOR';
export const CLEAR_COMMUNICATOR_STATE = 'CLEAR_COMMUNICATOR_STATE';